import _Card from "@mui/material/Card";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable camelcase */
import React from 'react';
import { node, object, string } from 'prop-types';
import clsx from 'clsx';
import SovosCardActions from '../sovos-card-actions';
import SovosCardContent from '../sovos-card-content';
import SovosCardHeader from '../sovos-card-header';
import { findChildByType, filterOutChildrenByType } from '../internals/utils/reactHelpers';
const SovosCard = _ref => {
  let {
    children,
    className,
    style,
    ...otherProps
  } = _ref;
  const header = findChildByType(children, SovosCardHeader);
  const actions = findChildByType(children, SovosCardActions);
  const content = findChildByType(children, SovosCardContent);
  const childrenToKeep = filterOutChildrenByType(children, SovosCardActions, SovosCardContent, SovosCardHeader);
  const contentToRender = content || /*#__PURE__*/React.createElement(SovosCardContent, null, childrenToKeep);
  return /*#__PURE__*/React.createElement(_Card, _extends({
    className: clsx('sovosCard', className),
    style: style
  }, otherProps), header, contentToRender, actions);
};
SovosCard.propTypes = {
  /**
   * The content of the card
   */
  children: node,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Inline styles applied to the root element
   */
  style: object
};
SovosCard.baseComponent = {
  name: 'Card',
  link: 'card/'
};
export default SovosCard;